import { Component } from 'react';

// Top-level error boundary. Previously a render error in any view would
// white-screen the whole app; now it shows a recoverable fallback and logs the
// error (the only client-side error logging in the app).
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleReset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        role="alert"
        className="max-w-[420px] my-20 mx-auto p-6 text-center bg-surface border border-line rounded-lg shadow-e1"
      >
        <div className="text-[32px] mb-2" aria-hidden="true">
          ⚠️
        </div>
        <h2 className="font-display text-ink mb-2">
          Er ging iets mis
        </h2>
        <p className="text-ink-2 text-[15px] mb-4">
          Deze weergave kon niet worden geladen. Probeer het opnieuw.
        </p>
        <button
          onClick={this.handleReset}
          className="bg-primary text-[#fff] border-none rounded-md py-[9px] px-4 font-display font-semibold cursor-pointer"
        >
          Opnieuw proberen
        </button>
      </div>
    );
  }
}
